// src/utils/marking.js
//
// Разбор кодов для модуля «Маркировка».
// Штрихкод (EAN/GTIN) — про «что за товар». Честный знак — GS1 Data Matrix:
//   01 + 14 цифр GTIN + 21 + серийник(+ крипто). «Общая часть» с баркодом = GTIN.
// В поле товара храним вытащенный GTIN (стабильная часть), а не разовый код.

// Привести любой код к 14-значному GTIN (для сравнения)
export function toGtin14(code) {
  const d = String(code || '').replace(/\D/g, '');
  if (!d) return '';
  return d.padStart(14, '0').slice(-14);
}

// Вытащить GTIN из отсканированного кода.
// Поддерживает чистый штрихкод (EAN-8/12/13/14) и GS1 Data Matrix ЧЗ.
export function extractGtin(raw) {
  if (!raw) return null;
  // убираем symbology identifier вроде ]d2 / ]C1 и пробелы
  let s = String(raw).trim().replace(/^\][A-Za-z0-9]/, '');
  // GS1: AI «01» + 14 цифр GTIN
  const m = s.match(/01(\d{14})/);
  if (m) return m[1];
  // чистый цифровой штрихкод
  const digits = s.replace(/\D/g, '');
  if (digits.length >= 8 && digits.length <= 14) return toGtin14(digits);
  return null;
}

// Похоже ли на код Честного знака (а не на обычный штрихкод)?
// Штрихкод — короткая чисто цифровая строка (EAN-8…GTIN-14).
// Всё остальное (есть буквы/символы ИЛИ длиннее 14 цифр) считаем кодом ЧЗ —
// у него есть уникальный серийник, и сверять такие коды надо целиком.
export function looksLikeDataMatrix(raw) {
  if (!raw) return false;
  const s = String(raw).trim().replace(/^\][A-Za-z0-9]/, '');
  if (!s) return false;
  return !/^\d{6,14}$/.test(s);
}

// Сверка для чекера: штрихкод vs код ЧЗ → один ли это товар (совпадает ли GTIN)
export function codesMatch(barcode, markRaw) {
  const g = extractGtin(markRaw);
  const b = toGtin14(barcode);
  if (!g || !b) return false;
  return toGtin14(g) === b;
}

// Совпадает ли товар с отсканированным кодом (по штрихкоду ИЛИ коду маркировки)
export function productMatchesScan(product, scannedRaw) {
  const g = extractGtin(scannedRaw);
  if (!g) return false;
  const gn = toGtin14(g);
  if (product.barcode && toGtin14(product.barcode) === gn) return true;
  if (product.markingCode && toGtin14(product.markingCode) === gn) return true;
  return false;
}

// Человекочитаемый вид кода для поля ввода.
// Сырой скан ЧЗ содержит символьный префикс (]d2/]C1) и непечатаемые
// разделители GS (\u001d) — input их не показывает («пустое» поле).
// Срезаем префикс и заменяем управляющие символы на видимую точку.
// ВАЖНО: только для отображения — в состоянии держим сырой код (нужен для склада).
export function displayCode(raw) {
  if (!raw) return '';
  return String(raw)
    .replace(/^\][A-Za-z][0-9]/, '')
    .replace(/[\u0000-\u001f\u007f-\u009f]/g, '·');
}
